'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreXMediatorType = void 0;
var CoreXMediatorType;
(function (CoreXMediatorType) {
    CoreXMediatorType["CASINO"] = "casino";
    CoreXMediatorType["SPORTS"] = "sports";
    CoreXMediatorType["MONETARY"] = "monetary";
    CoreXMediatorType["MONETARY_ADJUSTMENT"] = "monetary-adjustment";
})(CoreXMediatorType = exports.CoreXMediatorType || (exports.CoreXMediatorType = {}));
